"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Grid = require("../Grid");
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledForm = require("./StyledForm");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Item = /*#__PURE__*/function (_Component) {
  function Item() {
    (0, _classCallCheck2.default)(this, Item);
    return _callSuper(this, Item, arguments);
  }
  (0, _inherits2.default)(Item, _Component);
  return (0, _createClass2.default)(Item, [{
    key: "renderLabel",
    value: function renderLabel(theme) {
      var _this$props = this.props,
        formLayout = _this$props.formLayout,
        formLabelSpan = _this$props.formLabelSpan,
        labelSpan = _this$props.labelSpan,
        label = _this$props.label,
        viewMode = _this$props.viewMode,
        noPadding = _this$props.noPadding,
        children = _this$props.children,
        labelSuffix = _this$props.labelSuffix,
        observeElement = _this$props.observeElement;

      // İç içe FormItem kullanıldığında veya Input Spin gibi farklı bir şey ile sarıldığında çalışabilmesi için
      function isRequired(children) {
        var _children$props;
        if (typeof (children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.validation) === 'boolean') {
          var _children$props2;
          return children === null || children === void 0 ? void 0 : (_children$props2 = children.props) === null || _children$props2 === void 0 ? void 0 : _children$props2.validation;
        } else {
          var _children$props3, _children$props3$vali, _children$props4;
          return (children === null || children === void 0 ? void 0 : (_children$props3 = children.props) === null || _children$props3 === void 0 ? void 0 : (_children$props3$vali = _children$props3.validation) === null || _children$props3$vali === void 0 ? void 0 : _children$props3$vali.some(function (rule) {
            return rule.required == true;
          })) || (children === null || children === void 0 ? void 0 : (_children$props4 = children.props) === null || _children$props4 === void 0 ? void 0 : _children$props4.children) && isRequired(children.props.children);
        }
      }
      var labelElement = null;
      if (label || label === '') {
        labelElement = /*#__PURE__*/_react.default.createElement(_StyledForm.StyledFormItemLabel, {
          viewMode: viewMode,
          theme: theme
        }, label, isRequired(children) && ' * ', labelSuffix);
      }
      if (formLayout === 'horizontal') {
        var labelSpanOptions = labelSpan || formLabelSpan;
        return /*#__PURE__*/_react.default.createElement(_Grid.Col, (0, _extends2.default)({}, labelSpanOptions, {
          observeElement: observeElement,
          $noPadding: noPadding
        }), labelElement);
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, labelElement);
    }
  }, {
    key: "renderExtra",
    value: function renderExtra(theme) {
      var extra = this.props.extra;
      return extra ? /*#__PURE__*/_react.default.createElement(_StyledForm.StyledFormItemExtra, {
        theme: theme
      }, extra) : null;
    }
  }, {
    key: "renderItem",
    value: function renderItem(children, theme) {
      var _this$props2 = this.props,
        formLayout = _this$props2.formLayout,
        formColSpan = _this$props2.formColSpan,
        colSpan = _this$props2.colSpan,
        disabled = _this$props2.disabled,
        flexGroup = _this$props2.flexGroup,
        viewModeWithPrefixSuffix = _this$props2.viewModeWithPrefixSuffix;
      var Wrapper = _StyledForm.StyledFormItemInputContainer;
      var labelSpanOptions = {};
      if (formLayout === 'horizontal') {
        Wrapper = _StyledForm.StyledFormItemInputContainerCol;
        labelSpanOptions = colSpan || formColSpan;
      }
      var clonedChildren = _react.default.Children.map(children, function (child) {
        if (! /*#__PURE__*/_react.default.isValidElement(child)) {
          return child;
        }
        if ((child === null || child === void 0 ? void 0 : child.type) === _react.default.Fragment) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _react.default.Children.map(child.props.children, function (nestedChild) {
            var _nestedChild$props;
            if (! /*#__PURE__*/_react.default.isValidElement(nestedChild)) {
              return nestedChild;
            }
            var isNestedDisabled = (nestedChild === null || nestedChild === void 0 ? void 0 : (_nestedChild$props = nestedChild.props) === null || _nestedChild$props === void 0 ? void 0 : _nestedChild$props.disabled) || disabled;
            return /*#__PURE__*/_react.default.cloneElement(nestedChild, {
              disabled: isNestedDisabled
            });
          }));
        }
        var isDisabled = child.props.disabled || disabled;
        var isViewModeWithPrefixSuffix = child.props.viewModeWithPrefixSuffix || viewModeWithPrefixSuffix;
        return /*#__PURE__*/_react.default.cloneElement(child, {
          disabled: isDisabled,
          viewModeWithPrefixSuffix: isViewModeWithPrefixSuffix
        });
      });
      return /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({
        theme: theme
      }, labelSpanOptions, {
        flexGroup: flexGroup
      }), clonedChildren, this.renderExtra(theme));
    }
  }, {
    key: "renderItemWrapper",
    value: function renderItemWrapper(children, theme) {
      var formLayout = this.props.formLayout;
      var Wrapper = _react.default.Fragment;
      if (formLayout === 'horizontal') {
        Wrapper = _Grid.Row;
      }
      return /*#__PURE__*/_react.default.createElement(Wrapper, null, this.renderLabel(theme), this.renderItem(children, theme));
    }
  }, {
    key: "renderWrapper",
    value: function renderWrapper(children, theme) {
      var _this$props3 = this.props,
        formLayout = _this$props3.formLayout,
        formColSpan = _this$props3.formColSpan,
        colSpan = _this$props3.colSpan,
        hidden = _this$props3.hidden,
        lastChild = _this$props3.lastChild,
        hideOnViewMode = _this$props3.hideOnViewMode,
        className = _this$props3.className,
        viewMode = _this$props3.viewMode,
        noPadding = _this$props3.noPadding,
        observeElement = _this$props3.observeElement;
      var Wrapper = _react.default.Fragment;
      var colSpanOptions = {};
      if (formLayout === 'horizontal') {
        Wrapper = _Grid.Row;
        colSpanOptions = {
          span: 24
        };
      } else {
        colSpanOptions = colSpan || formColSpan;
      }
      return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_StyledForm.StyledFormItemWrapper, (0, _extends2.default)({
        lastChild: lastChild,
        hidden: hidden || viewMode && hideOnViewMode,
        layout: formLayout,
        theme: theme,
        className: className,
        noPadding: noPadding,
        observeElement: observeElement
      }, colSpanOptions), children));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return _this.renderWrapper(_this.renderItemWrapper(_this.props.children, theme), theme);
      });
    }
  }]);
}(_react.Component);
Item.propTypes = {
  displayName: _propTypes.default.string,
  hideOnViewMode: _propTypes.default.bool,
  viewMode: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  noPadding: _propTypes.default.bool,
  labelSuffix: _propTypes.default.node,
  observeElement: _propTypes.default.oneOf(['container', 'window'])
};
Item.defaultProps = {
  displayName: 'FormItem',
  hideOnViewMode: false,
  noPadding: false,
  labelSuffix: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
  // disabled: false,
  observeElement: 'window'
};
var _default = exports.default = Item;